import { useClerk } from "@clerk/react"
import { createFileRoute } from "@tanstack/react-router"
import { ShieldXIcon } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
	Card,
	CardContent,
	CardFooter,
	CardHeader,
	CardTitle,
} from "@/components/ui/card"
import { env } from "@/env"

export const Route = createFileRoute("/unauthorized")({
	component: UnauthorizedPage,
})

function UnauthorizedPage() {
	const { signOut } = useClerk()

	const handleSignOut = async () => {
		await signOut()
		window.location.href = "/"
	}

	const handleBackToPlatform = () => {
		window.location.href = env.VITE_MAIN_APP_URL || "http://localhost:4200"
	}

	return (
		<div className="flex min-h-screen items-center justify-center bg-background p-4">
			<Card className="w-full max-w-md">
				<CardHeader className="text-center">
					<div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
						<ShieldXIcon className="h-8 w-8 text-destructive" />
					</div>
					<CardTitle className="text-2xl">Access Denied</CardTitle>
				</CardHeader>
				<CardContent className="text-center text-muted-foreground">
					You do not have the required account permissions to access this
					platform. Please contact an administrator for further support.
				</CardContent>
				<CardFooter className="flex flex-col gap-2">
					<Button
						onClick={handleBackToPlatform}
						className="w-full"
						variant="default"
					>
						Back to Platform
					</Button>
					<Button onClick={handleSignOut} variant="outline" className="w-full">
						Sign Out
					</Button>
				</CardFooter>
			</Card>
		</div>
	)
}
